'use client';

import clsx from 'classnames';
import Link from 'next/link';
import { useEffect, useRef } from 'react';
import { Button, useOnScreen } from 'ui';

import {
  selectPromotion,
  viewPromotion,
} from '@/modules/google/data-layer/data-layer';
import { TextOnlyBannerModule } from '@/shared/banners/types';

import styles from './TextOnlyBanner.module.scss';

export function TextOnlyBanner({
  data,
  bannerId,
  name,
  slot,
}: {
  data?: TextOnlyBannerModule['data'];
  bannerId: number;
  name: string;
  slot?: string | null;
}) {
  const ref = useRef(null);
  const { onScreen, disconnect } = useOnScreen(ref);

  const handleLinkClick = () => {
    selectPromotion(name, `P${bannerId}`, slot);
  };

  useEffect(() => {
    if (!onScreen) {
      return;
    }

    disconnect();
    viewPromotion(name, `P${bannerId}`, slot);
  }, [onScreen]);

  return (
    <Link
      prefetch={false}
      href={data?.url || '#'}
      className={clsx(
        'Banner',
        styles.TextOnlyBanner__wrapper,
        'TextOnlyBanner'
      )}
      style={{
        background: data?.background || '#ccc',
      }}
      ref={ref}
      onClick={handleLinkClick}
    >
      {!!data?.text && (
        <p
          className={clsx(
            styles.TextOnlyBanner__heading,
            'TextOnlyBanner__heading'
          )}
          style={{ color: data.color || '#000' }}
        >
          {data.text}
        </p>
      )}
      {!!data?.text2 && (
        <p
          className={clsx(styles.TextOnlyBanner__text, 'TextOnlyBanner__text')}
          style={{ color: data.color || '#000' }}
        >
          {data.text2}
        </p>
      )}
      {!!data?.text3 && (
        <p
          className={clsx(
            styles.TextOnlyBanner__text2,
            'TextOnlyBanner__text2'
          )}
          style={{ color: data.color || '#000' }}
        >
          {data.text3}
        </p>
      )}
      {!!data?.button && !!data.url && (
        <div
          className={clsx(
            styles.TextOnlyBanner__button,
            'TextOnlyBanner__button'
          )}
        >
          <Button
            variant={
              data.buttonStyle === 'outline' ? 'customOutlined' : 'custom'
            }
            color={data.buttonColor || '#000'}
            background={data.buttonBackground || '#ccc'}
          >
            {data.button}
          </Button>
        </div>
      )}
    </Link>
  );
}
